import type {ServiceResponsePayload} from '@igp/shared/api';
import type {ReferralLinkConfig} from '@igp/shared/contract/pam';
import type {AsyncActionMeta} from '@igp/shared/redux/async-action';
import {createAsyncAction} from 'typesafe-actions';

import type {EditReferralLinkConfigPayload, RemoveReferralLinkConfigPayload} from './types';

const domain = 'referral-link-config' as const;

export const referralLinkConfigActions = {
    addReferralLinkConfig: createAsyncAction(
        `${domain}/addReferralLinkConfigRequest`,
        `${domain}/addReferralLinkConfigSuccess`,
        `${domain}/addReferralLinkConfigFailure`
    )<
        [EditReferralLinkConfigPayload, AsyncActionMeta],
        [ServiceResponsePayload<EditReferralLinkConfigPayload, ReferralLinkConfig>, AsyncActionMeta],
        [ServiceResponsePayload<EditReferralLinkConfigPayload, ReferralLinkConfig>, AsyncActionMeta]
    >(),
    editReferralLinkConfig: createAsyncAction(
        `${domain}/editReferralLinkConfigRequest`,
        `${domain}/editReferralLinkConfigSuccess`,
        `${domain}/editReferralLinkConfigFailure`
    )<
        [EditReferralLinkConfigPayload, AsyncActionMeta],
        [ServiceResponsePayload<EditReferralLinkConfigPayload, ReferralLinkConfig>, AsyncActionMeta],
        [ServiceResponsePayload<EditReferralLinkConfigPayload, ReferralLinkConfig>, AsyncActionMeta]
    >(),
    removeReferralLinkConfig: createAsyncAction(
        `${domain}/removeReferralLinkConfigRequest`,
        `${domain}/removeReferralLinkConfigSuccess`,
        `${domain}/removeReferralLinkConfigFailure`
    )<
        [RemoveReferralLinkConfigPayload, AsyncActionMeta],
        [ServiceResponsePayload<RemoveReferralLinkConfigPayload, ReferralLinkConfig>, AsyncActionMeta],
        [ServiceResponsePayload<RemoveReferralLinkConfigPayload, ReferralLinkConfig>, AsyncActionMeta]
    >(),
} as const;
